import React, { useState, memo, useEffect, Fragment } from "react";
import axios from 'axios';
import { useRecoilState, useRecoilValue } from "recoil";
import DayPickerInput from "react-day-picker/DayPickerInput";
import MomentLocaleUtils from "react-day-picker/moment";
import moment from 'moment';
import "react-day-picker/lib/style.css";
import "moment/locale/ja";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { PrefOptionList } from '../../common/parts/PrefOptionList';
import { SubmitButton } from '../parts/SubmitButton';
import { formatDatetimeDisplay } from '../../../services/calendar';

import { examOrderState } from '../../../store/examOrderState';
import { orderInfoState } from '../../../store/orderInfoState';
import { currentStatusState } from '../../../store/currentStatusState';

export const FormExam = memo((props) => {
  const { cm, user, staff_user, self_order, cource_pattern, clinics } = props;
  const [examOrderData, setExamOrderData] = useRecoilState(examOrderState);
  const [orderInfoData, setOrderInfoData] = useRecoilState(orderInfoState);
  const [currentStatus, setCurrentStatus] = useRecoilState(currentStatusState);

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  const onChangeStatus = (e) => {
    setCurrentStatus(e.target.value);
  }

  const onChangeClinic = (e) => {
    let clinic = clinics.find(clinic => clinic.id === Number(e.target.value));
    setExamOrderData({
      ...examOrderData,
      examclinic_id: clinic.id,
      examclinic: clinic.name,
    });
  }

  // 日付をYYYY-MM-DDの書式で返すメソッド
  const formatDate = (dt) => {
    const formatRules = [
      "YYYY-MM-DD", "YYYY/MM/DD", "YYYYMMDD",
    ]
    let formatedDate = moment(dt, formatRules).format('YYYY-MM-DD');
    return formatedDate;
  }

  const onChangeExamDt = (selectedDay, modifiers, dayPickerInput) => {
    const input = dayPickerInput.getInput();
    setExamOrderData({...examOrderData, examdtdate: formatDate(input.value)});
  }
  const onChangeExamTm = (e) => {
    setExamOrderData({...examOrderData, examdtime: e.target.value});
  }

  const onChangeNote = (e) => {
    setExamOrderData({...examOrderData, examnote: e.target.value});
  }

  const onClickSubmit = () => {
    const sure = window.confirm('Are you sure to submit ?');
    if (sure) {
      const examdt = `${examOrderData.examdtdate} ${examOrderData.examdtime}`;

      var data = {
        proxy_checkup: {
          fix_staff_users_id: staff_user,
          status: currentStatus,
          examclinic_id: examOrderData.examclinic_id,
          examclinic: examOrderData.examclinic,
          examdt: examdt,
          examnote: examOrderData.examnote,
        },
        employee_id: user.id,
      };

      // axios csrfToken
      const csrfToken = document.querySelector('[name=csrf-token]').content
      axios.defaults.headers.common['X-CSRF-Token'] = csrfToken
  
      axios.put(`/agent/employees/${user.id}/checkup_operation/${examOrderData.id}`, data)
      .then(resp => {
        console.log("Proxy CheckupOp api ok");
        console.log(resp.data);
        setExamOrderData({
          ...examOrderData,
          status: resp.data.status,
          // examdt: resp.data.examdt,
        });
        setOrderInfoData({
          ...orderInfoData,
          status: resp.data.status,
        });
        notify("success", "Proxy CheckupOp Update Success!");
      })
      .catch(e => {
        console.log("Proxy CheckupOp api ng");
        console.log(e.response);
        alert(JSON.parse(e.request.responseText).errors);
        notify("error", "Proxy CheckupOp Update Error!");
      });
    }
  }

  const stateDisplay = () => {
    return (
      <div className="input-group mb-3">
        <label className="input-group-text" htmlFor="todofukenselect">ステータス</label>
        <select value={currentStatus} className="form-select" aria-label="Default select edit" id="statusselect" onChange={onChangeStatus} >
          <option value="" disabled></option>
          <option value="order_init" disabled>申込中</option>
          <option value="order_changed" disabled>申込変更中</option>
          <option
            value="order_readjusted"
            disabled={cource_pattern == 'ineligibles' ? true : false}
          >
            再調整
          </option>
          <option
            value="order_commited"
            disabled={cource_pattern == 'ineligibles' ? true : false}
          >
            予約確定
          </option>
          <option
            value="order_finished"
            disabled={cource_pattern == 'ineligibles' ? true : false}
          >
            受診確認完了
          </option>
          <option value="order_not_ineligible">対象外（未受診）</option>
          <option value="order_not_ineligible_retired">対象外（退職）</option>
          <option value="order_not_ineligible_leave">対象外（産育休）</option>
          <option value="order_not_ineligible_exception">結果票待（提携外）</option>
        </select>
      </div>
    )
  }

  const clinicDateDisplay = () => {
    if (currentStatus == 'order_init' || currentStatus == 'order_changed' || currentStatus == 'order_commited' || currentStatus == 'order_finished') {
      switch(cource_pattern){
        case 'request_cource':
        case 'jigo_cource':
          return (
            <Fragment>
              <div className="input-group">
                <label className="input-group-text" htmlFor="todofukenselect">医療機関</label>
                <select value={examOrderData.examclinic_id} className="form-select" aria-label="Default select edit" id="clinicselect" onChange={onChangeClinic} >
                <option value="" disabled>医療機関を選択</option>
                {clinics?.map(item => 
                  <option key={item.id} value={item.id}>{item.name}</option>
                )}
                </select>
              </div>
              <div>確定済医療機関名：{examOrderData.examclinic}</div>
              <div className="input-group mt-3 mb-3">
                <span className="input-group-text" id="basic-name1">受診日時</span>
                <DayPickerInput
                  inputProps={{ 
                    className: 'form-control',
                  }}
                  dayPickerProps={{
                    localeUtils: MomentLocaleUtils,
                    locale: "ja",
                  }}
                  placeholder='日付を選択(必須)'
                  onDayChange={onChangeExamDt}
                  value={examOrderData.examdtdate}
                />
                <input className="form-control" type="time" value={examOrderData.examdtime} onChange={onChangeExamTm} />
              </div>
            </Fragment>
          )
        case 'junkai_cource':
        case 'seiken_cource':
          return (
            <Fragment>
              <div className="input-group mb-3">
                <span className="input-group-text" id="basic-name1">医療機関</span>
                <div className="form-control">{examOrderData.examclinic}</div>
              </div>
              <div className="input-group mb-3">
                <span className="input-group-text" id="basic-name1">受診日時</span>
                <div className="form-control">{formatDatetimeDisplay(examOrderData.examdt)}</div>
              </div>
            </Fragment>
        )
      }
    }
  }

  const textareaDisplay = () => {
    if (currentStatus == 'order_init' || currentStatus == 'order_changed' || currentStatus == 'order_readjusted' || currentStatus == 'order_commited' || currentStatus == 'order_finished') {
      return (
        <div className="mb-3">
          <textarea className="form-control" id="exampleFormControlTextarea1" rows="5" placeholder="その他特記事項" onChange={onChangeNote} value={examOrderData.examnote || ''}></textarea>
        </div>
      )
    }
  }

  return (
    <>
      <div className="card-body">
        { stateDisplay() }
        { clinicDateDisplay() }
        { textareaDisplay() }
        <SubmitButton 
          text="送信"
          onClick={onClickSubmit}
          isDisabledVal={
            self_order
            && currentStatus ? false : true
          }
        />
      </div>
    </>
  );
});